<template>
  <el-dialog class="open-case-dialog" title="" append-to-body :visible.sync="dialogVisible" close-on-click-modal center :top="isMobile ? '20vh' : '15vh'" :width="isMobile ? '100%' : '800px'"
    :before-close="handleClose">
    <div class="gift-dialog-content">
      <slot></slot>
    </div>
  </el-dialog>
</template>

<script>
import responsiveMixin from "@/mixins/responsive";
export default {
  name: "GiftDialog",
  mixins: [responsiveMixin],
  components: {},
  props: {},
  data() {
    return {
      dialogVisible: false,
    };
  },
  mounted() { },
  methods: {
    handleClose() {
      this.dialogVisible = false;
    }
  }
};
</script>

<style lang="scss" scoped>
@import "./index.scss";
</style>
